import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { FirebaseHelper } from '../../firebase-helper';
import './PostPage.scss';
import Image from '../../components/Image/Image';
import CommentForm from '../../components/CommentForm/CommentForm';
import CommentCard from '../../components/CommentCard/CommentCard';
import LikeButtons from '../../components/LikeButtons/LikeButtons';


function PostPage() {
    const { id } = useParams();

    const [post, setPost] = useState();
    const [comments, setComments] = useState();

    useEffect(() => {
        const getPost = async () => {
            var thePost = await FirebaseHelper.getDoc("posts", id)
            FirebaseHelper.increaseView("posts",id);
            console.log("Post Fetched")
            setPost(thePost)
            var theComments = []
            thePost.comments.map(async (commentId) => {
                var commentSnapshot = await FirebaseHelper.getDoc("comments", commentId);
                theComments.push({ id: commentId, comment: commentSnapshot });
            })
            console.log("Comments Fetched");
            setComments(theComments);
        }
        getPost();

    }, []);



    const parseContent = (content) => {
        var splitContent = content.split("\n").filter((element) => { return element != "" });
        return splitContent.map((row, index) => {
            switch (row.charAt(0)) {
                case "#":
                    return (<img key={index} className='post-image' src={row.substring(1)} />);
                case "-":
                    if(row.substring(row.length-1)=="-"){
                        return (<div key={index} className='post-title'>{row.substring(1).substring(0,row.length-2)} </div>);
                    }
                    return (<div key={index} className='post-side-title'>{row.substring(1)} </div>);
                case "~":
                    return (<Image key={index} className='post-image' path="Wallpapers" id={row.substring(1)} type="" />);
                default:
                    return (<div key={index} className='post-text'>{row}</div>);
            }

        })
    }
    return (post &&
        <div className='post-page container'>
            <div className='post-page-wallpaper'>
                {post && <Image path="PostImages" id={id} type="wallpaper" />}
            </div>
            <div className='post-page-container'>
                <div className='post-header'>
                    <h1>{post && post.title}</h1>
                </div>
                <div className='post-page-content'>
                    <div>{post && parseContent(post.content)}</div>
                </div>
            </div>
            <div className='post-like-buttons-container'>
                <LikeButtons id={id} type="posts" likes={post.likes} dislikes={post.dislikes} clickAble={true} object={post} />
            </div>
            <div className='comment-form-container'>
                <CommentForm id={id} />
            </div>
            <div className='comments-container'>
                {
                    comments && comments.map((comment) => {
                        return (
                            <CommentCard key={comment.id} id={comment.id} comment={comment.comment} />
                        );
                    })
                }
            </div>
            
        </div>

    )
}

export default PostPage